/**
 * GP Popups Frontend Entry Point
 *
 * Initializes the popup manager with configurations from PHP.
 */

import { PopupManager } from './popup-manager';
import { createLogger } from '../shared/logger';
import './styles/index.css';

const logger = createLogger('Frontend');

// Initialize when DOM is ready
function init(): void {
	logger.group('Initialization', () => {
		logger.log('init() called');
		logger.log('window.gpPopupsConfig:', window.gpPopupsConfig);

		// Check if we have popup configurations
		if (!window.gpPopupsConfig || !Array.isArray(window.gpPopupsConfig)) {
			logger.log('No popup configurations found, exiting');
			return;
		}

		logger.log(`Found ${window.gpPopupsConfig.length} popup config(s)`);

		// Create and initialize the popup manager
		const manager = new PopupManager();
		logger.log('PopupManager created, initializing with configs...');
		manager.init(window.gpPopupsConfig);
		logger.log('PopupManager initialized');
	});
}

// Run on DOM ready
logger.log('Script loaded, document.readyState:', document.readyState);
if (document.readyState === 'loading') {
	logger.log('Adding DOMContentLoaded listener');
	document.addEventListener('DOMContentLoaded', init);
} else {
	logger.log('DOM already ready, calling init immediately');
	init();
}
